export default "__VITE_ASSET__M3VQlM7o__"